
import React, { useEffect, useState, useMemo } from 'react';
export const LayoutContext = React.createContext({});

export const LayoutProvider = (props) => {
    const mobileSize = 1000;
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [pageTitle, setPageTitle] = useState();
    const [showPageTitle, setShowPageTitle] = useState(false);
    const [showBackButton, setShowBackButton] = useState(false);
    const [backButtonLabel, setBackButtonLabel] = useState();
    const [backButtonNavigateTo, setBackButtonNavigateTo] = useState();
    const [actionButtons, setActionButtons] = useState(null);
    const [backButtonHandleOnClick, setBackButtonHandleOnClick] = useState(null);
    const [switchMenuHandleOnClick, setSwitchMenuHandleOnClick] = useState(null);

    const [isMobile, setIsMobile] = useState(window.innerWidth < mobileSize);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < mobileSize);
        }
        window.addEventListener('resize', handleResize);     
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    // useEffect(() => {
    //     setSidebarCollapsed(isMobile);        

    // }, [isMobile]);
   
    const value = useMemo(() => ({
        sidebarCollapsed, setSidebarCollapsed, isMobile,
        pageTitle, setPageTitle,
        showPageTitle, setShowPageTitle,
        showBackButton, setShowBackButton,
        backButtonLabel, setBackButtonLabel,
        backButtonNavigateTo, setBackButtonNavigateTo,
        actionButtons, setActionButtons,
        backButtonHandleOnClick, setBackButtonHandleOnClick,
        switchMenuHandleOnClick, setSwitchMenuHandleOnClick
    }), [
        sidebarCollapsed, isMobile,
        pageTitle, showPageTitle,
        showBackButton, backButtonLabel, backButtonNavigateTo,
        actionButtons,
        backButtonHandleOnClick,
        switchMenuHandleOnClick
    ]);

    return (
        <React.Fragment>
            <LayoutContext.Provider value={value}>{props.children}</LayoutContext.Provider>
        </React.Fragment>
    );
};